<template>
  <div class="home">
    <ChangePassword :appName="appName" />
  </div>
</template>

<script>
// @ is an alias to /src
import ChangePassword from '@/components/ChangePassword.vue'

export default {
  props:['appName'],
  name: 'ChangePasswordView',
  components: {
    ChangePassword
  }
}
</script>
